module.exports = __webpack_public_path__ + "img/CM-SS-24-Subaru-Modern.1b8824c3.jpg";